import { DEFAULT_TEXT_DURATION, INTRO_OUTRO_DEFAULT_DURATION } from '@/constants';
import { VideoThemeClipTypeEnum } from '@/enums/VideoThemeClipEnum';
import { ThemeProp, TributeVideoOptionsType, VideoThemeClipResponse } from '@/types';

export const generateOrderOptions = (count: number, isEditPage: boolean) => {
  const max = isEditPage ? count : count + 1;

  return Array.from({ length: max + 1 }, (_, i) => ({
    value: i,
    label: i.toString()
  }));
};

export const calculateThemeDuration = (
  selectedAsset: ThemeProp,
  tributeVideoOptions?: TributeVideoOptionsType,
  videoThemeClips?: VideoThemeClipResponse
): number => {
  if (!tributeVideoOptions) {
    return selectedAsset.duration;
  }

  const { introEnabled, outroEnabled, textsEnabled } = tributeVideoOptions;

  const clips = videoThemeClips?.data || [];

  const introDuration = clips
    .filter((clip) => clip.type === VideoThemeClipTypeEnum.INTRO)
    .reduce((sum, clip) => sum + (clip.duration || 0), 0);

  const outroDuration = clips
    .filter((clip) => clip.type === VideoThemeClipTypeEnum.OUTRO)
    .reduce((sum, clip) => sum + (clip.duration || 0), 0);

  const textDuration = textsEnabled ? DEFAULT_TEXT_DURATION : 0;
  let duration = selectedAsset.duration;

  // Both intro and outro OFF
  if (!introEnabled && !outroEnabled) {
    return 2 * INTRO_OUTRO_DEFAULT_DURATION + textDuration;
  }

  // intro OFF
  if (!introEnabled) {
    duration = duration - introDuration + INTRO_OUTRO_DEFAULT_DURATION + textDuration;
  }

  // outro OFF
  if (!outroEnabled) {
    duration = duration - outroDuration + INTRO_OUTRO_DEFAULT_DURATION;
  }

  return duration;
};
